<template>
    <div class="openClass content">
        <Form :label-width="120" style="width: 50%" ref="formValidate" :model="formValidate">
            <FormItem label="机构名称">
                <p>{{name}}</p>
            </FormItem>

            <FormItem label="手机号">
                <div class="info" v-if="list.length>0">
                    <div v-for="item in list" class="info_list">
                        <p style="margin-left: 10px">{{item.tid}}</p>
                        <Icon :type="item.status==1?'ios-checkmark':'ios-close'" size="24"
                              :color="item.status==1?'green':'red'"/>
                    </div>
                    <div class="num">开通成功{{successNum}}条,失败{{failNum}}条</div>
                </div>
                <Input v-model="formValidate.mobiles" placeholder="请输入 “手机号 空格 姓名” 或“手机号”格式，例如：15288888888 或 15288888888 小花"
                       type='textarea' style="width: 300px;" :autosize="{minRows:10,maxRows: 20}"
                       v-if="list.length==0"></Input>
                <!--<Input v-model="formValidate.mobiles" type="textarea" :autosize="{minRows: 10,maxRows: 20}"-->
                       <!--placeholder="请输入手机号" v-if="list.length==0"></Input>-->
            </FormItem>
            <FormItem label="需要完善资料">
                <RadioGroup v-model="type">
                    <Radio label="1">是</Radio>
                    <Radio label="2">否</Radio>
                </RadioGroup>
            </FormItem>

            <FormItem label="">
                <Button size="large" type="primary" style="margin-right: 20px;" @click="submit()"
                        :disabled="this.formValidate.mobiles?false:true">确定
                </Button>
                <Button size="large" type="warning" style="margin-right: 20px;" @click="edit()">重置</Button>
                <Button size="large" type="success" style="margin-right: 20px;" @click="getBack()">返回</Button>
            </FormItem>
        </Form>
    </div>
</template>
<style scoped>
    .info {
        border: 1px solid #ccc;
        min-height: 300px;
        border-radius: 3px;
    }

    .info_list {
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .num {
        width: 50%;
        margin: 20px auto;
        background: #666;
        color: #fff;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 17px;
    }
</style>
<script>
    import {
        DatePicker,
    } from 'iview';
    import http from "../../../libs/http.js"
    import util from "../../../libs/util.js"
    export default {
        components: {
            DatePicker,
        },
        data() {
            return {
                gardenId: this.$route.query.gardenId,
                name: this.$route.query.name,
                tidList: [],
                formValidate: {
                    mobiles: '',
                },
                list: [],
                successNum: '',
                failNum: '',
                type:'',
            }
        },
        created() {

        },
        methods: {
            submit() {
                let _this = this
                var _data = {
                    opt:2,
                    gardenId:_this.gardenId,
                    mobiles: _this.formValidate.mobiles,
                    type:_this.type
                }
                if (!_this.type) {
                    _this.$Message.warning('请选择是否完善资料')
                }else {
                    http.post('/custom/madyUser/opt', _data).then(res => {
                        if (res) {
                            _this.list = res.list
                            this.successNum = res.success
                            _this.failNum = res.fail
                            this.$Message.success('添加成功' + res.success + '条失败' + res.fail + '条')
                            this.formValidate.phone = ''
                        }
                    })
                }

            },
            edit() {
                this.formValidate = {}
                this.list = []
                this.type = ''
            },
            getBack() {
                this.$router.go(-1)
            }
    }
    }
</script>
